<script setup>
import { onBeforeMount, ref } from 'vue'
import { getKeyGuest } from '@/api/2023/index.js'
import { RightOutlined } from '@ant-design/icons-vue'

const guestArr = ref([])
let guestArrPage = ref(null)
const guestPage = ref([])
const tagNum = ref(0)

function toPitch(index) {
  tagNum.value = index
  guestPage.value = pagination(tagNum.value + 1, 10, guestArr.value)
}
function toMore() {
  const path = `${window.location.origin}/new/2023/guest.html`
  window.open(path)
}
function pagination(pageNo, pageSize, array) {
  var offset = (pageNo - 1) * pageSize
  return offset + pageSize >= array.length
    ? array.slice(offset, array.length)
    : array.slice(offset, offset + pageSize)
}

const getInfo = () => {
  getKeyGuest()
    .then((res) => {
      guestArr.value = res.data.data
      guestArrPage.value = Math.round(guestArr.value.length / 10)
      guestPage.value = pagination(1, 10, guestArr.value)
    })
    .catch(() => {})
}

onBeforeMount(async () => {
  await getInfo()
})
</script>
<template>
  <div class="isc">
    <img class="iscBgc" src="https://p0.ssl.qhimg.com/t01d17161bff7a9c927.png" alt="背景图" />
    <div class="wrap">
      <p class="iscTitle">重磅嘉宾</p>
      <p class="iscDesc">IMPORTANT GUESTS</p>
      <ul class="iscNav">
        <li v-for="(item, index) in guestPage" :key="index" class="iscNavList">
          <img :src="item.avatar" alt="头像" />
          <p class="title">{{ item.name }}</p>
          <p class="desc">
            <span v-for="(i, j) in item.title" :key="j">
              {{ i }}
              <span v-if="j !== item.title.length - 1">,</span>
            </span>
          </p>
        </li>
      </ul>
      <ul class="iscDots">
        <li
          v-for="(item, index) in guestArrPage"
          :key="item"
          :class="tagNum === index ? 'pitch' : ''"
          @click="toPitch(index)"
        ></li>
      </ul>
      <div class="iscMore" @click="toMore">查看更多<right-outlined /></div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.isc {
  position: relative;
  width: 100%;
  height: 970px;
  background-color: #f7f8fc;
  text-align: center;
  padding-top: 106px;
  &Bgc {
    position: absolute;
    top: 67px;
    left: 50%;
    transform: translateX(-50%);
    width: 724px;
    height: 456px;
  }
  &Dots {
    margin-top: 38px;
    margin-bottom: 20px;
    li {
      cursor: pointer;
      display: inline-block;
      list-style: none;
      width: 8px;
      height: 8px;
      background: #bdc4ca;
      border-radius: 50%;
      margin-right: 8px;
    }
    .pitch {
      background-color: #00ab7a;
    }
  }
  &Title {
    font-size: 40px;
    font-weight: bold;
    line-height: 32px;
    color: #3d3d3d;
    margin: 0;
  }
  &Desc {
    font-size: 28px;
    line-height: 32px;
    color: #3d3d3d;
    margin: 12px 0 66px;
  }
  &Nav {
    width: 1196px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 0 auto;
    &List {
      display: inline-block;
      width: 180px;
      height: 212px;
      text-align: center;
      list-style: none;
      margin: 0 10px 32px;
      img {
        width: 130px;
        height: 130px;
        border-radius: 50%;
        margin: auto;
        background-color: #fff;
      }
      .title {
        font-weight: bold;
        font-size: 20px;
        color: #222222;
        margin: 14px 0 6px;
      }
      .desc {
        font-size: 12px;
        color: #222222;
      }
    }
  }
  &More {
    width: 160px;
    height: 52px;
    line-height: 52px;
    background: #00ab7a;
    border-radius: 2px;
    margin-top: 66px;
    margin: 0 auto;
    font-weight: bold;
    font-size: 20px;
    color: #ffffff;
    cursor: pointer;
  }
}
</style>
